import React, { useCallback } from 'react';

import SearchResultsCore, { SearchResultsCoreProps } from '../components/SearchResultsCore';
import useThunkDispatch from '../hooks/useThunkDispatch';
import { AjaxResponse } from '../services/ajaxRequest';
import { Actions, Models, Search, State } from '../types';

export type SearchActionCreator<SearchType extends Models.Base, ParamsType> = (
  searchParams: ParamsType
) => (
  dispatch: Actions.ThunkDispatch,
  getState: () => State.Root
) => Promise<AjaxResponse<SearchType> | undefined>;

function NoGroupSearchResults<
  SearchType extends Models.Search,
  ModelType extends Models.Base,
  ParamsType extends Search.Params
>(
  props: SearchResultsCoreProps<SearchType, ModelType, ParamsType> & {
    loadDataActionCreator: SearchActionCreator<SearchType, ParamsType>;
  }
) {
  const { loadDataActionCreator, searchParams, ...coreProps } = props;
  const dispatch = useThunkDispatch();

  const dispatchLoadAction = useCallback(
    async () => dispatch(loadDataActionCreator(searchParams)),
    [dispatch, loadDataActionCreator, searchParams]
  );

  return (
    <SearchResultsCore
      {...coreProps}
      dispatchLoadAction={dispatchLoadAction}
      searchParams={searchParams}
    />
  );
}

export default NoGroupSearchResults;
